// extracted by mini-css-extract-plugin
export default {"content":"HeroContent_content__FeFze","title":"HeroContent_title__c-i+r","description":"HeroContent_description__p6+Gr","control":"HeroContent_control__m9RtE"};